import React from "react";
import { Container } from "./styles";
import { ReactComponent as BtnArrow } from "assets/arrowbtn2.svg";
import ellipse3 from "assets/ellipse3.png";
import { Link } from "react-router-dom";

function Index({ title_tip, title, cardDetails, bg, fontColor}) {
  return (
    <Container bg={bg} fontColor={fontColor}>
      <div className="wrapper">
        <div className="header">
          <span>{title_tip}</span>
          <p className="title">{title}</p>
        </div>
        <div className="content">
          {cardDetails?.map(({ header_tip, header, desc, btnText, more_link}, index) => {
            return (
              <div className="card" key={header + desc + index}>
                <span>{header_tip}</span>
                <h1 className="card-header">{header}</h1>
                <p className="desc">{desc}</p>
                <button className="more-btn">
                  <Link to={more_link}>
                    {btnText} <BtnArrow />
                  </Link>
                </button>
              </div>
            );
          })}
        </div>
      </div>
      <img src={ellipse3} alt="ellipse" />
    </Container>
  );
}

export default Index;
